export enum RemoveSystemValidationFailedReason {
  LinkedDevices = 'LinkedDevices',
  IntercomMappings = 'IntercomMappings',
}
